import { useState, useEffect } from 'react';

let hidden: 'hidden' | 'msHidden' | 'webkitHidden';
let visibilityChange: 'visibilitychange' | 'msvisibilitychange' | 'webkitvisibilitychange';

declare global {
  interface Document {
    msHidden?: boolean;
    webkitHidden?: boolean;
  }
}

if (typeof document.hidden !== 'undefined') {
  hidden = 'hidden';
  visibilityChange = 'visibilitychange';
} else if (typeof document.msHidden !== 'undefined') {
  hidden = 'msHidden';
  visibilityChange = 'msvisibilitychange';
} else if (typeof document.webkitHidden !== 'undefined') {
  hidden = 'webkitHidden';
  visibilityChange = 'webkitvisibilitychange';
}

export const isTabFocused = () => !document[hidden];
export const getVisibilityChangeEventName = () => visibilityChange;

export const useAppVisibility = () => {
  const [ visibilityStatus, setVisibilityStatus ] = useState(!document[hidden]);

  useEffect(() => {
    function handleVisibilityChange() {
      setVisibilityStatus(isTabFocused());
    }

    document.addEventListener(visibilityChange, handleVisibilityChange, { capture: true });

    return () => {
      document.removeEventListener(visibilityChange, handleVisibilityChange);
    };
  }, []);

  return visibilityStatus;
};
